import { loadCookie, removeCookie } from '@shared/utils/cookies';
import { appHref, assignLocation } from '@shared/utils/appHref';

const COOKIE_DOMAIN = (import.meta.env.VITE_COOKIE_DOMAIN as string | undefined) || undefined;

/**
 * Landing-page redirect for already-authenticated visitors. On domain-split
 * deployments the session `token` cookie is domain-scoped (VITE_COOKIE_DOMAIN)
 * so it is visible here on the marketing host; the dashboard itself lives on
 * the app host, hence a full-page navigation instead of a router navigate.
 *
 * A pre-split host-only `token` on the marketing host is stale by definition
 * (sessions are created on the app host now) and would bounce logged-out
 * visitors into the app login forever — drop it before checking.
 */
export const bounceAuthenticatedVisitor = (): void => {
  if (COOKIE_DOMAIN) removeCookie('token', { path: '/' });
  if (loadCookie<string>('token')) {
    assignLocation(appHref('/dashboard'));
  }
};
